import React, { Fragment, useEffect, useState } from 'react';
import { BCTabContainer } from './BCTabContainer';
import { translate } from '../../../Services/translation';
import { BCinvoiceRow } from '../BCInvoiceRow';
import { getInvoices } from "../../../Services/BusinessCentral/BusinessCentral.service";
import { BCSpinner } from "../BCSpinner";

export const Invoices = () => {
    const [loading, setLoading] = useState(true);
    const [orders, setOrders] = useState([]);

    useEffect(() => {
        getInvoices().then(response => {
            setOrders(response.invoices);
        }).finally(() => {
            setLoading(false);
        });
    }, []);

    return (
        <BCTabContainer title={translate('business.invoicetab.header')}>
            <div className="businesscentral__invoiceTab__context">
                <h3 className="businesscentral__invoiceTab__context__header">
                    {translate('business.invoicetab.subheader')}
                </h3>

                {loading ? (
                        <div className="BusinessCentral__usersTabContent__table__loading">
                            <BCSpinner/>
                        </div>
                    ) :
                    <Fragment>
                        <div className="businesscentral__invoiceTab__context__table">
                            <div className="businesscentral__invoiceTab__context__headers">
                                <p>{translate('business.invoicetab.ordernr')}</p>
                                <p>{translate('business.invoicetab.date')}</p>
                                <p>{translate('business.invoicetab.priceegvat')}</p>
                                <p>{translate('business.invoicetab.contactperson')}</p>
                            </div>
                            {
                                orders.length === 0 ?
                                    <div
                                        className="businesscentral__invoiceTab__context__table__body">
                                        {translate('business.invoicetab.empty')}
                                    </div> :

                                    <div className="businesscentral__invoiceTab__context__table__body">
                                        {orders.map((order, index) => (
                                            <BCinvoiceRow key={index} order={order}/>
                                        ))}
                                    </div>
                            }
                        </div>
                    </Fragment>
                }
            </div>
        </BCTabContainer>
    );
};
